import { render, staticRenderFns } from "./carPick.vue?vue&type=template&id=4afd3244"
import script from "./carPick.vue?vue&type=script&lang=js"
export * from "./carPick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports